<lf-general-dialog-layout class="fileset-modal">
  <span lf-widget class="dialog-header">{{ 'lf_fileset_select_file' | localize: lfFilesetLocalizeHelper }}</span>
  <button type="button" icon-button class="dialog-header" (click)="onClose()">
      <svg class="tool-bar-icon" title="close">
          <use xlink:href="#_svg-close"></use>
      </svg>
  </button>
  <div class="dialog-content" style="height:auto; overflow:hidden">
    <lf-message-toast *ngIf="toastMessages.length > 0" class="toast-messages relative" [messages]="toastMessages"></lf-message-toast>
    <div *ngIf="!isLoading && toastMessages.length == 0" class="browser-search">
      <input [(ngModel)]="searchString" (keyup.enter)="onSearchValueChange()" placeholder="{{ 'lf_fileset_search_files' | localize: lfFilesetLocalizeHelper }}">
      <button class="browser-search-icon" (click)="onSearchValueChange()">
        <svg style="width:24px;height:24px" title="search">
          <use xlink:href="#_svg-search"></use>
        </svg>
      </button>
    </div>
    <lf-repository-browser-component
      [hidden]="isLoading && toastMessages.length == 0" class="lf-explorer"
      multiple="true"
      [isSelectable]="selectable"
      (entrySelected)="onComponentNodesSelected($event)"
      style="height: 400px"
      #repoBrowser
    ></lf-repository-browser-component>
  </div>
  <div class="dialog-footer">
    <button type="button" lf-button (click)="onConfirm()" buttontype='primary' [disabled]="!isSelectedNodeFile">{{ 'lf_fileset_confirm' | localize: lfFilesetLocalizeHelper }}</button>
    <button type="button" lf-button (click)="onClose()">{{ 'lf_fileset_cancel' | localize: lfFilesetLocalizeHelper }}</button>
  </div>
</lf-general-dialog-layout>